﻿
window.addEventListener("message", evt => {
    try {
        if (typeof evt.data !== 'string') {
            return;
        }

        if (evt.data === "OpenInquiryPopup") {
            Component.openInquiryForm(evt);
            console.warn('Message with data "OpenInquiryPopup" is depricated, use {"action": "OpenInquiryPopup"} in data instead');
            return;
        }

        const jsonData = JSON.parse(evt.data);
        switch (jsonData.action) {
            case "OpenInquiryPopup":
                Component.openInquiryForm(evt);
                break;
            case "AddProductToCart":
                Component.addProductToCart(jsonData.data.productId, jsonData.data.quantity);
                break;
            case "AddProductWithCustomDataToCart":
                Component.addProductToCart(jsonData.data.productId, jsonData.data.quantity, jsonData.data.customData);
                break;
            case "ClosePopup":
                Component.closePopup(evt);
                break;
            default:
                console.warn(`Unsupported action! ACTION: ${jsonData.action}`);
        }

    } catch (e) {
        return false;
    }
});

window.openPopup = function (html) {
    console.log('OBSOLETE - use Component.openPopup');
    return Component.openPopup(html);
}

window.getAllowedCookies = function(){
    console.log('OBSOLETE - use Component.getAllowedCookies');
    return Component.getAllowedCookies();
}

window.getCookie = function (cookieName) {
    console.log('OBSOLETE - use Component.getCookie');
    return Component.getCookie(cookieName);
}

